"use client"

import * as Sentry from "@sentry/nextjs"
import { NavigationProvider } from "@/providers/NavigationProvider/NavigationProvider"
import { SessionProvider } from "next-auth/react"
import ReactQueryProvider from "./ReactQueryProvider"
import { useEffect } from "react"
import type { NovaSession } from "@/types"

const ClientProviders = ({
  children,
  serverSession,
}: Readonly<{
  children: React.ReactNode
  serverSession: NovaSession | null | undefined
}>) => {
  useEffect(() => {
    if (serverSession?.user) {
      Sentry.setUser({
        id: serverSession.user.id,
        uuid: serverSession.user.uuid,
        creativeId: serverSession.user.creative?.id,
        clientId: serverSession.user.client?.id,
        creativeHandle: serverSession.user.creative?.handle,
        clientHandle: serverSession.user.client?.handle,
        accountType: serverSession.account,
      })
    }
  }, [serverSession])

  return (
    <ReactQueryProvider>
      <SessionProvider>
        <NavigationProvider>{children}</NavigationProvider>
      </SessionProvider>
    </ReactQueryProvider>
  )
}

export default ClientProviders
